import * as React from 'react';
import { createContextValueGetter, emptyFn } from '../../utils/helper';
export var MenuItemContext = React.createContext({
    itemStyle: undefined,
    clickHandler: emptyFn,
    selectedIds: [],
});
export var getMenuItemContext = createContextValueGetter();
export var SubMenuContext = React.createContext({
    zIndex: 10000,
    visible: true,
    type: 'normal',
    horizontalPlacement: 'right',
    viewportMargin: 2,
});
export var getSubMenuContext = createContextValueGetter();
export var ContextMenuContext = React.createContext({
    visible: true,
    onClick: emptyFn,
});
export var getContextMenuContext = createContextValueGetter();
